import _ from 'lodash'
import { convertSpecialSymbols } from '@/common/resources/directives'
const CELL_TYPE_PATH = ['cell_toplist', 'cell_type']
export default {
  data () {
    return {
      cellType: '',
      cellList: [],
      filter: null,
      title: ''
    }
  },
  methods: {
    getData (response) { return response.data },
    setCellType (data) { this.cellType = _.get(data, CELL_TYPE_PATH, ''); return data },
    setCellList (data) { this.cellList = _.get(data, ['cell_toplist', 'celllist'], []); return data },
    clearCellList (data) { this.cellList = []; return data },
    setFilter (data) { this.filter = _.get(data, 'filter', {}); return data },
    setTitle (data) { this.title = convertSpecialSymbols(_.get(data, ['cell_toplist', 'title_list', '0', 'text'], '')); return data }
  }
}
